import { render, staticRenderFns } from "./ConsultarSolicitacaoAlteracaoValor.vue?vue&type=template&id=35ab548f&scoped=true"
import script from "./ConsultarSolicitacaoAlteracaoValor.vue?vue&type=script&lang=js"
export * from "./ConsultarSolicitacaoAlteracaoValor.vue?vue&type=script&lang=js"
import style0 from "./ConsultarSolicitacaoAlteracaoValor.vue?vue&type=style&index=0&id=35ab548f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab548f",
  null
  
)

export default component.exports